export enum DeviceCategories
{
    DPU = "DPU",
    VisionDesktop = "VisionDesktop",
    Ultralight = "Ultralite",
    FlowBack = "FlowBack",
    TCP = "TCP"
}